import { useCallback, useState } from 'react'

import { get } from '@/services/operators/get'

export const useOperatorGet = () => {
  const [isLoading, setIsLoading] = useState(false)

  const operatorGet = useCallback(
    async (
      description: string,
      creationDate: string,
      userId: string,
      userName: string,
      unitId: string,
      operatorId: string
    ) => {
      try {
        setIsLoading(true)
        const response = await get({
          descricao: description,
          dataCriacao: creationDate,
          usuarioId: userId,
          nomeUsuario: userName,
          unidadeId: unitId,
          operadoraId: operatorId
        })

        return response || ''
      } catch (error) {
        console.error('Error get operator:', error)
        return error
      } finally {
        setIsLoading(false)
      }
    },
    []
  )

  return { operatorGet, isLoading }
}
